import { NgModule } from '@angular/core';
import { GalaxyBackgroundComponent } from './galaxy-background.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        GalaxyBackgroundComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        GalaxyBackgroundComponent
    ]
})
export class NcGalaxyBackgroundModule { }